import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { User } from "../../../users/models/user";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
  FormControl
} from "@angular/forms";
import { FormValidationService } from "../../../../shared/services/form-validation.service";

@Component({
  selector: "app-first-signin-form",
  template: require('./first-signin-form.component.html'),
  styles: [require('./first-signin-form.component.sass')]
})
export class FirstSigninFormComponent implements OnInit {
  @Input() user: User;
  @Output() updatePassword = new EventEmitter<{
    newPassword: string;
    confirmPassword: string;
  }>();

  public firstLoginForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder, 
    public formValidation:FormValidationService
    ) {
    this.firstLoginForm = this.formBuilder.group({
      newPassword: [
        null,
        [
          Validators.required,
          Validators.pattern(/^(?=.*\d)(?=.*?[^\w\s])(?=.*[A-Z]).{10,255}$/)
        ]
      ],
      confirmPassword: [
        null,
        [Validators.required, this.ValidatorMatchingPassword.bind(this)]
      ]
    });
  }

  ngOnInit(): void {}

  updateLoginInformation = () => {
    if (this.firstLoginForm.valid) {
      this.updatePassword.emit({
        newPassword:
          this.firstLoginForm.value && this.firstLoginForm.value.newPassword,
        confirmPassword:
          this.firstLoginForm.value && this.firstLoginForm.value.confirmPassword
      });
    } else {
      this.formValidation.validateAllFormFields(this.firstLoginForm);
    }
  };

  ValidatorMatchingPassword(control: AbstractControl): ValidationErrors | null {
    const password = this.firstLoginForm?.value?.newPassword;
    const confirm = control?.value;
    if (password !== confirm) {
      return {
        noMatch: true
      };
    }
    return null;
  }
}
